
































































































import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import { CampaignFilters } from "@/models/campaign";
import Company from "@/models/company";
import { QueryParams } from "@/models/general";
import User from "@/models/user";
import CompanyAPI from "@/services/companies";
import UsersAPI from "@/services/users";
import { CampaignModule } from "@/store/campaign";
import { LayoutModule } from "@/store/layout";
import { cloneDeep, orderBy } from "lodash";
import { Vue, Component, Prop } from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";

@Component({
  components: { DatePicker },
})
export default class CampaignFilter extends Vue {
  @Prop({ default: null }) user!: User;

  statusList = CAMPAIGN_STATUS_LIST;
  companies: Company[] = [];
  users: User[] = [];
  filter: CampaignFilters | null = null;

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  get currentFilter(): CampaignFilters {
    return this.filter as CampaignFilters;
  }

  async created(): Promise<void> {
    LayoutModule.showLoader();
    await this.getCompanies();
    await this.getUsers();
    this.filter = cloneDeep(CampaignModule.getCurrentFilter);

    this.user ? (this.filter.user_id = [this.user.id.toString()]) : null;

    LayoutModule.hideLoader();
  }

  cancel(clean = false): void {
    if (clean) {
      const filter = new CampaignFilters();
      this.user ? (filter.user_id = [this.user.id.toString()]) : null;
      CampaignModule.setCampaignFilter({
        ...filter,
        dateRange: [],
      });
    }

    LayoutModule.hideRightDrawer();
  }

  apply(): void {
    console.log(this.filter);
    if (this.filter && !Array.isArray(this.filter?.dateRange)) {
      this.filter.dateRange = [];
    }

    CampaignModule.setCampaignFilter(this.filter as CampaignFilters);
    LayoutModule.hideRightDrawer();
  }

  async getCompanies(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await CompanyAPI.getCompanies(params);
      this.companies = orderBy(r.data, ["name"], ["asc"]);
    } catch (e) {
      console.log(e);
    }
  }

  async getUsers(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await UsersAPI.getUsers(params);
      this.users = orderBy(r.data, ["name"], ["asc"]);
    } catch (e) {
      console.log(e);
    }
  }

  // setDateRange(d: string | string[]): void {
  //   d.length === 2 ? (this.filter.dateRange as = d as string[]) : null;
  // }
}
